<template>
  <div class="share-detail-page">
    <!-- <div class="banner">
      <img class="img-responsive" src="./images/1586955980-22640856_n.png" alt />
    </div> -->
    <div class="banner banner-2501">
      <Banner loc="6-2" :baseBtn="false"/>
      <!-- <div class="tx-wrap">
        <div class="tx-box">
          <div class="tx1">浪漫荷葉性感鏤空內衣</div>
          <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
          <div class="tx3">MOMOOMOMOM</div>
        </div>
        <button class="add-cart-btn" @click="goProductDetail">{{ $t('btns.check_product') }}</button>
      </div> -->
      <!-- <img class="img-responsive" src="./images/img_line_up01.png" alt /> -->
    </div>
    <div class="breadcrumbs c-layout">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.share') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{data.name}}</span>
    </div>
    <div class="content c-layout detail-content-dc">
      <div class="date"><span>{{moment(data.createTime).format("MMM DD ddd YYYY")}}</span><span>By mtBRA</span></div>
      <div class="title">{{data.name}}</div>
      <div class="auther">{{data.createName}}</div>
      <div class="desc" v-html="data.content">
        
      </div>
    </div>

    <GoodsFlexible :list="recentGoods"  :title="$t('goodsFlexible.recent')" sub-title="RECENT" tag="hot" />
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import GoodsFlexible from "@/components/GoodsFlexible";
import { getShareDetail } from "@/api";
import moment from "moment";
import Mixin from "@/utils/goodsMixin";

export default {
    mixins:[Mixin],
  data() {
    return {
      data: "",
    };
  },
  mounted() {
    let { id } = this.$route.query;
    getShareDetail({ id }).then((res) => {
      this.data = res.share;
    });

  },
  methods: {
    moment,
    goProductDetail() {
      this.$router.push({ name: "goodsDetail", query: { goods_id: this.data.product_no } });
    }
  },
  components: {
    GoodsFlexible,
    Banner
  },
};
</script>

<style scoped lang='less'>
.share-detail-page {
  .banner {
    width: 100%;
    // height: 675px;
  }
  .breadcrumbs {
    .p-16 {
      padding: 0 16px;
    }
    .o-color {
      color: var(---unnamed-color-ec4f00);
    }
    padding: 35px 0;

    font-size: 16px;
    line-height: 24px;
    color: var(---unnamed-color-707070);
  }
  .content {
    margin-bottom: 120px;
  }
  .goods-flexble-comp {
    margin-bottom: 30px;
  }
  @media (max-width: 992px) {
    .banner {
      // height: 330px;
    }
    .breadcrumbs {
      display: none;
    }
    .content {
      padding: 20px;
      .date {
        text-align: left;
        font-size: 1rem;
        padding-bottom: .5rem;
        display: flex;
        justify-content: space-between;
      }
      .title {
        text-align: left;
        font-size: 1.8rem;
        line-height: 2.4rem;
        padding-bottom: 2rem;
      }
      .desc {
        letter-spacing: 2px;
      }
    }
    .go-back-btn {
      width: 100%;
      margin-bottom: 0;
    }
  }
  .banner-2501 {
    width: 100%;
    // height: 650px;
    position: relative;
    .tx-wrap {
      position: absolute;
      bottom: 10%;
      left: 13.8%;
      z-index: 1;
    }
    .tx-box {
      .tx1 {
        font-size: 32px;
        line-height: 50px;
        font-weight: 500;
        color: var(--unnamed-color-ffffff);
      }
      .tx2,
      .tx3 {
        padding-top: 15px;
        font-size: 16px;
        line-height: 24px;
        color: var(--unnamed-color-ffffff);
      }
    }
    .add-cart-btn {
      margin-top: 36px;
      cursor: pointer;
      width: 125px;
      height: 40px;
      background: var(--unnamed-color-ffffff);
      border: 1px solid var(--unnamed-color-ffffff);
      font-size: 13px;
      line-height: 20px;
      color: var(--unnamed-color-000000);
    }
    @media (max-width:992px) {
      .tx-wrap {

      }
      .tx-box {
        .tx1 {
          font-size: 22px;
          line-height: 25px;
          font-weight: 500;
          color: var(--unnamed-color-ffffff);
        }
        .tx2,
        .tx3 {
          padding-top: 5px;
          font-size: 15px;
          line-height: 15px;
          color: var(--unnamed-color-ffffff);
        }
      }
      .add-cart-btn {
        margin-top: 20px;
        width: 100px;
        height: 30px;
      }
    }
  }
  .desc {
    span {
      white-space: break-spaces !important;
    }
  }
}
</style>
